import {
  FETCH_ALL_SKILL_CENTRES_SUCCESS,
  CREATE_SKILL_CENTRE_SUCCESS,
  EDIT_SKILL_CENTRE_SUCCESS,
  ACTIVATE_SKILL_CENTRE_SUCCESS,
  DEACTIVATE_SKILL_CENTRE_SUCCESS,
  RESTORE_SKILL_ACQUISITION_CENTRE_INITIAL,
  FETCH_TOTAL_SKILL_CENTER_DETAILS_SUCCESS,
  MAKE_REQUEST,
  FETCH_SKILL_CENTER_SELECT_SUCCESS,
  EMPTY_SKILL_CENTER_SELECT,
} from "../ActionTypes";
 

const INIT_STATE = {
  allCentres: [],
  tablePaginationData: {},
  ascTotalLevelData: {},
  skillCenterSelectFetched: [],
  
  isFetched: false,
  ascCreatedSuccessfully: false,
  ascEditedSuccessfully: false,
  ascActivatedSuccessfully: false,
  ascDeactivatedSuccessfully: false,

  fetchingDataGeneral: true,
  makingRequest: false,
  isLoading:true,
}


function reducers(state = INIT_STATE, action) {
  switch (action.type) {
    case FETCH_ALL_SKILL_CENTRES_SUCCESS: return {
      ...state,
      allCentres: action.payload.data,
      tablePaginationData: action.payload.meta,
      fetchingDataGeneral: false,
      makingRequest: false,
    }

    case FETCH_TOTAL_SKILL_CENTER_DETAILS_SUCCESS: return {
      ...state,
      ascTotalLevelData: action.payload,
      isLoading:false
    }

    case CREATE_SKILL_CENTRE_SUCCESS: {
      const {id, name, isActive} = action.payload
      const newCentre = {
        id: id,
        name: name, 
        isActive: isActive,
      }

      return {
        ...state,
        ascCreatedSuccessfully: true,
        allCentres: state.allCentres.push(newCentre),
        makingRequest: false,
        fetchingDataGeneral: true,
      }
    }

    case EDIT_SKILL_CENTRE_SUCCESS: return {
      ...state,
      ascEditedSuccessfully: true,
      makingRequest: false,
      fetchingDataGeneral: true,
    }

    case ACTIVATE_SKILL_CENTRE_SUCCESS: return {
      ...state,
      ascActivatedSuccessfully: true,
      makingRequest: false,
      fetchingDataGeneral: true,
    }

    case DEACTIVATE_SKILL_CENTRE_SUCCESS: return {
      ...state,
      ascDeactivatedSuccessfully: true,
      makingRequest: false,
      fetchingDataGeneral: true,
    }

    case RESTORE_SKILL_ACQUISITION_CENTRE_INITIAL: return {
      ...state,
      ascCreatedSuccessfully: false,
      ascEditedSuccessfully: false,
      ascActivatedSuccessfully: false,
      ascDeactivatedSuccessfully: false,
    }

    case MAKE_REQUEST: return {
      ...state,
      makingRequest: true,
    }
    case FETCH_SKILL_CENTER_SELECT_SUCCESS: {
      return {
        ...state,
        skillCenterSelectFetched: action.payload.data,
        isFetched: true,
      };
    }
    case EMPTY_SKILL_CENTER_SELECT: {
      return {
        ...state,
        skillCenterSelectFetched: [],
      };
    }
  
    default: return state;
  }
}

export default reducers;